import React from "react";
import { Role } from "@store/types";
import { State, getRoles } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useRoles(
  application_id?: number,
  environment_name?: string
): Data<Role[] | null> {
  const dispatch = useDispatch();
  const key = `${application_id}:${environment_name}`;
  const [roles, error, fetching] = useSelector((state: State) => [
    state.roles[key],
    state.network.error.roles[key],
    state.network.fetching.roles[key],
  ]);

  React.useEffect(() => {
    if (application_id && environment_name && !roles && !fetching && !error) {
      dispatch(getRoles(application_id, environment_name));
    }
  }, [application_id, environment_name, dispatch, roles, error, fetching]);

  return [roles, error, fetching];
}
